export default __webpack_public_path__ + "static/media/step_10_container_settings.d642096a.png";